import { Component, Input } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ThemingService } from "src/app/core/service/theme/theming.service";

@Component({
    selector: "app-overlay-spinner",
    templateUrl: "./overlay-spinner.component.html",
    styleUrls: ["./overlay-spinner.component.scss"]
})
export class OverlaySpinnerComponent {
    public primary$: Observable<string>;
    public secondary$: Observable<string>;

    constructor(private themeService: ThemingService) {
        this.primary$ = this.themeService.currentThemeAsync.pipe(
            map((theme) => {
                return theme.images.primaryLogoUrl;
            })
        );
        this.secondary$ = this.themeService.currentThemeAsync.pipe(
            map((theme) => {
                return theme.images.secondaryLogoUrl;
            })
        );
    }

    @Input()
    public show!: boolean;

    @Input("color")
    public color: "primary" | "secondary" = "primary";
}
